/* eslint-disable @typescript-eslint/no-explicit-any */

/**export const setupTamBids = (
  containerID: string,
  adUnitName = '',
  sizes: Array<number[]> = [],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  definedSlot: any
) => {
  Logger.log('setupTamBids', containerID, adUnitName, sizes, definedSlot.getSlot);
  const apstag = window.apstag || {};
  // request the bids for the for googletag slots
  apstag.fetchBids(
    {
      slots: [
        {
          slotID: containerID, //example: div-gpt-ad-1475102693815-0
          slotName: adUnitName, //example: //example: /116082170/slot2
          sizes //example: [[300,250],[300, 600]]
        }
      ]
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    function (bids: any[]) {
      const googletag = window.googletag;
      // set apstag bids, then trigger the first request to GAM
      googletag.cmd.push(function () {
        apstag.setDisplayBids();
        googletag.display(definedSlot);
        googletag.pubads().refresh([definedSlot]);
      });
    }
  );
  //
  
};**/

export function setupTamBids(
  containerID: string,
  adUnitName = '',
  sizesArray: Array<string | number[]> = [],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  definedSlot: any
) {
  window.PWT.bidsReceived[containerID] = {};
  const apstag = window.apstag || {};
  const googletag = window.googletag;
  apstag.fetchBids(
    {
      slots: [
        {
          slotID: containerID,
          slotName: adUnitName,
          sizes: sizesArray
        }
      ]
    },
    function () {
      // set apstag bids, then trigger the first request to GAM
      // googletag.cmd.push(function () {
      apstag.setDisplayBids();
      // googletag.display(definedSlot);
      // googletag.pubads().refresh([definedSlot]);
      if (!definedSlot) {
        const slot = window.googletag
          .pubads()
          .getSlots()
          .find((slot: any) => slot.getSlotElementId() === containerID);
        window.PWT.bidsReceived[containerID].TAM_BidsReceived = true;
        window.initAdserver(false, slot, containerID);
      } else {
        window.PWT.bidsReceived[containerID].TAM_BidsReceived = true;
        window.initAdserver(false, definedSlot, containerID);
      }

      // });
    }
  );

  // OpenWrap code START here
  googletag.cmd.push(function () {
    const currentSlot =
      definedSlot ||
      window.googletag
        .pubads()
        .getSlots()
        .find((slot: any) => slot.getSlotElementId() === containerID);
    // if (isRefresh) {
    if (typeof window.PWT.removeKeyValuePairsFromGPTSlots === 'function') {
      window.PWT.initAdserverFlag = false;
      // first remove already added OpenWrap targeting key value pairs from slots
      // window.PWT.removeKeyValuePairsFromGPTSlots([currentSlot]);
      // now call OpenWrap to get bids and add respective key value pairs
      window.PWT.requestBids(
        window.PWT.generateConfForGPT([currentSlot]),
        function (adUnitsArray: any) {
          window.PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
          window.PWT.bidsReceived[containerID].ow_BidsReceived = true;
          window.initAdserver(false, currentSlot, containerID);
        }
      );
    }
    // } else {
    //   if (typeof window.PWT.requestBids === 'function') {
    //     window.initAdserverFlag = false;
    //     console.log('Bids fetched from open wrap');
    //     window.PWT.requestBids(
    //       window.PWT.generateConfForGPT([currentSlot]),
    //       function (adUnitsArray: Slot[]) {
    //         window.PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
    //         window.PWT.bidsReceived[containerID].ow_BidsReceived = true;
    //         window.initAdserver(false, currentSlot, containerID);
    //       }
    //     );
    //   }
    // }

    const FAILSAFE_TIMEOUT = 1500; // this timeout should be more than OpenWrap and TAM timeout
    const initAdServerTimeout = setTimeout(function () {
      clearTimeout(initAdServerTimeout);
      window.initAdserver(true, currentSlot, containerID); // calling this function with forced mode set to true so that GPT API is always executed
    }, FAILSAFE_TIMEOUT);
  });
}
